function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M3.3 7.717l3.9 3.9 3.9-3.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.2 1.433v9.534m4.767 2.6H2.433"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.967 13.067a.5.5 0 01.09.992l-.09.008H2.433a.5.5 0 01-.09-.992l.09-.008h9.534zM7.2.933a.5.5 0 01.492.41l.008.09v8.976l3.046-3.046a.5.5 0 01.638-.058l.07.058a.5.5 0 01.057.638l-.057.07-3.9 3.9a.5.5 0 01-.638.057l-.07-.058-3.9-3.9a.5.5 0 01.638-.765l.07.058 3.045 3.046.001-8.976a.5.5 0 01.5-.5z",
  fill: "currentColor",
  fillRule: "nonzero"
}));

var SvgIconDownload = function SvgIconDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_download.4acf0947.svg";
export { ForwardRef as ReactComponent };